import React, { useState, useRef } from "react";
import "../style/slider.css";

import before from "../img/before.webp";
import after from "../img/after.webp";

const SliderBeforeAfter = () => {
  const [position, setPosition] = useState(50);
  const containerRef = useRef(null);

  // Funkcija za pomeranje slajdera
  const handleMouseMove = (e) => {
    if (containerRef.current) {
      const container = containerRef.current.getBoundingClientRect();
      const offsetX = e.clientX - container.left;
      const newPosition = (offsetX / container.width) * 100;

      // Ograničavanje vrednosti između 0% i 100%
      setPosition(Math.max(0, Math.min(100, newPosition)));
    }
  };

  const handleTouchMove = (e) => {
    if (containerRef.current) {
      const container = containerRef.current.getBoundingClientRect();
      const offsetX = e.touches[0].clientX - container.left;
      const newPosition = (offsetX / container.width) * 100;

      setPosition(Math.max(0, Math.min(100, newPosition)));
    }
  };

  return (
    <div
      className="image-comparison-container"
      ref={containerRef}
      onMouseMove={handleMouseMove}
      onTouchMove={handleTouchMove}
    >
      {/* Slika posle */}
      <div
        className="after-image"
        style={{
          backgroundImage: `url(${after})`,
        }}
      />

      {/* Slika pre */}
      <div
        className="before-image"
        style={{
          width: `${position}%`,
          backgroundImage: `url(${before})`,
        }}
      />

      {/* Linija za prevlačenje */}
      <div
        className="slider"
        style={{
          left: `${position}%`,
        }}
      />
    </div>
  );
};

export default SliderBeforeAfter;
